import { BASE_URL } from './Config.js';

export class ApprovisionnementService {

   
  // ── Fetch approvisionnement ──────────────────────────────────────────────────
    // ── Fetch approvisionnement (Aplatit les lignes de tous les en-têtes) ─────
  fetchApprovisionnement = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/approvisionnement/all`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    
    const approvisionnements = await response.json();
    
    // Aplatir les lignes de tous les en-têtes d'approvisionnement
    let allLines = [];
    if (Array.isArray(approvisionnements)) {
      approvisionnements.forEach(appro => {
        if (appro.lines && Array.isArray(appro.lines)) {
          appro.lines.forEach(line => {
            allLines.push({
              ...line,
              approvisionnementId: appro.id,
              status: appro.status || 'DRAFT' // Hérite du statut du parent
            });
          });
        }
      });
    }
    return allLines;
  };

  // 2. Clôture l'approvisionnement (appel au backend qui déclenchera la transformation BCF)
  closeApprovisionnement = async (approvisionnementId) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/approvisionnement/close/${approvisionnementId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    
    return await response.json();
  };

    // Créer un nouvel approvisionnement avec ses lignes
  createApprovisionnement = async (dto) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/approvisionnement/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify(dto)
    });
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
    return await response.json();
  };

    // Clôturer une seule ligne d'approvisionnement
  closeLine = async (lineId) => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/approvisionnement/closeLine/${lineId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Erreur clôture ligne approvisionnement');
    return await response.json();
  };

    // Récupérer toutes les lignes d'approvisionnement (et non les parents)
  fetchAllLines = async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('Token manquant');

    const response = await fetch(`${BASE_URL}/approvisionnement/lines/all`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Erreur récupération des lignes d\'approvisionnement');
    return await response.json();
  };
}